/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Waterkeeperdefect2Inputs */



/**
* | output |
* | --- |
* | "Booster pump defect" |
*
* @param {Br_History_Key_Waterkeeperdefect2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_waterkeeperdefect2 = /** @type {((inputs?: Br_History_Key_Waterkeeperdefect2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Waterkeeperdefect2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Booster pump defect")
	return /** @type {LocalizedString} */ ("Défaut du surpresseur")
});
export { br_history_key_waterkeeperdefect2 as "br_history_key_waterKeeperDefect" }